import classnames from "classnames";
import { usePrefersReducedMotion } from "neetocommons/react-utils";
import { Typography } from "neetoui";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";

import AddNew from "./AddNew";
import Block from "./Block";
import Item from "./Item";
import "./menubar.scss";
import Search from "./Search";
import SubTitle from "./SubTitle";

const MenuBar = ({
  title = "",
  children,
  showMenu = false,
  className = "",
  ...otherProps
}) => {
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <CSSTransition
      unmountOnExit
      classNames="neeto-molecules-menubar"
      in={showMenu}
      timeout={prefersReducedMotion ? 0 : 300}
    >
      <div
        className={classnames("neeto-molecules-menubar__wrapper", {
          [className]: className,
        })}
      >
        <div
          className="neeto-molecules-menubar__container"
          data-testid="menubar-container"
        >
          {title && (
            <Typography
              className="neeto-molecules-menubar__title"
              data-testid={otherProps["data-testid"] || "menubar-heading"}
              lineHeight="tight"
              style="h2"
              weight="semibold"
            >
              {title}
            </Typography>
          )}
          {children}
        </div>
      </div>
    </CSSTransition>
  );
};

MenuBar.Block = Block;
MenuBar.Item = Item;
MenuBar.SubTitle = SubTitle;
MenuBar.Search = Search;
MenuBar.AddNew = AddNew;

MenuBar.propTypes = {
  /**
   * To specify the content to be rendered as the title for the `MenuBar`.
   */
  title: PropTypes.node,
  /**
   * To specify the content to be rendered inside the `MenuBar`.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   * To specify whether the MenuBar is visible or not.
   */
  showMenu: PropTypes.bool,
  /**
   * To specify external classnames for the MenuBar.
   */
  className: PropTypes.string,
};

export default MenuBar;
